import React, { useState } from 'react';
import './PayrollUpload.css';
import AddMembersChecklist from './AddMembersChecklist';
import fetchBase from "../utils/fetchBase";

const PayrollUpload = ({ onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState('');

    const [missingClients, setMissingClients] = useState([]);
    const [missingCaregivers, setMissingCaregivers] = useState([]);
    const [showChecklistModal, setShowChecklistModal] = useState(false);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setMessage('');
    };

    const handleUpload = async () => {
        if (!file) return setMessage('Please select a file.');

        setUploading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {

            const res = await fetch(`${fetchBase}/api/payroll/upload`, {
                method: 'POST',
                body: formData,
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("jwt_token"),
                }
            });

            const data = await res.json();
            console.log('🧾 Backend responded with:', data);

            if (res.ok) {

                // 🔹 Store header and column index for template generation
                // These will only run if the backend returns those fields
                if (data.headerRow && data.clientColIndex !== undefined) {
                    localStorage.setItem("headerRow", JSON.stringify(data.headerRow));
                    localStorage.setItem("clientColIndex", data.clientColIndex.toString());
                }


                if (data.missingClients.length > 0 || data.missingCaregivers.length > 0) {
                    setMissingClients(data.missingClients);
                    setMissingCaregivers(data.missingCaregivers);
                    setShowChecklistModal(true);
                } else {
                    setMessage('✅ No missing clients or caregivers!');

                    // Wait for backend template generation instead of faking it
                    onUploadSuccess();   // <-- Your parent component should call /generate-template

                }
            } else {
                setMessage('❌ Upload failed.');
            }
        } catch (error) {
            setMessage('❌ An error occurred.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="upload-page-wrapper">
            <div className="payroll-upload-container">
                {!showChecklistModal && (
                    <>
                        <h2>Upload Your Payroll Master Sheet</h2>
                        <p>This file should be a complete excel billing sheet containing full client list.</p>
                        <input
                            type="file"
                            accept=".xlsx,.xls"
                            onChange={handleFileChange}
                        />
                        <button onClick={handleUpload} disabled={uploading}>
                            {uploading ? 'Uploading...' : 'Upload'}
                        </button>
                        <p className="message">{message}</p>
                    </>
                )}

                {showChecklistModal && (
                    <AddMembersChecklist
                        missingClients={missingClients}
                        missingEmployees={missingCaregivers}
                        onClose={() => {
                            setShowChecklistModal(false);
                            window.location.href = '/admin/payroll?tab=live';
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default PayrollUpload;